/**
 * react-intl requires the locale to be formatted with a dash
 * https://github.com/formatjs/formatjs/discussions/2440
 *
 * dayjs locale is updated for the appropriate date/time formatting and parsing
 *
 * @param locale - The locale string to normalize (e.g., 'en_US', 'zh_CN')
 * @returns The normalized locale string with dashes (e.g., 'en-US', 'zh-CN')
 *
 * @example
 * normalizeLocale('en_US') // returns 'en-US'
 * normalizeLocale('zh_CN') // returns 'zh-CN'
 * normalizeLocale('en-US') // returns 'en-US' (already normalized)
 */
export const normalizeLocale = (locale) => {
    return locale.replace('_', '-');
};
//# sourceMappingURL=normalizeLocale.js.map